import { defineComponent as _defineComponent } from 'vue'
import NewAutocomplete from '@/components/vision/next/inputs/NewAutocomplete.vue'
import { SearchOptions } from '@/components/vision/next/inputs/UseNewAutocomplete'
import { PickerItemType } from '@/components/vision/next/picker-list/models'
import { computed, Ref, ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import Division from '@/models/division'
import { orderBy } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobDivisionPicker',
  props: {
    value: { default: null },
    jobHubId: null,
    isDisabled: { type: Boolean }
  },
  emits: ["autofill", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'autofill', field: string, value: string): void
  (e: 'input', id: string | null | undefined): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null, jobHubId: string, isDisabled: boolean }





const store = useStore()
const divisionsForHub = computed<(hubId: string) => Division[]>(() => {
  return store.getters['divisions/getDivisionsForHub']
})
const getDivisionByUuid = computed<
  (id?: string | null) => Division | undefined
>(() => store.getters['divisions/getByUuid'])
const isLoadingDivisions = computed(() => store.state.divisions.loading)
const isDivisionsLoaded = computed(() => !isLoadingDivisions.value)
const divisions = computed(() => divisionsForHub.value(props.jobHubId))

watch(
  isDivisionsLoaded,
  (loaded) => {
    if (loaded && divisions.value.length === 1) {
      emit('autofill', 'division', divisions.value[0].uuid ?? '')
    }
  },
  { immediate: true }
)

const searchDivisions = (options: Ref<SearchOptions>) => {
  const items = computed<Readonly<PickerItemType[]>>(() => {
    return orderBy(
      divisions.value
        .filter((d) =>
          d.name
            ?.toLowerCase()
            .includes(options.value.searchText?.toLowerCase() ?? '')
        )
        .map((l) => ({
          id: l.uuid,
          title: l.name,
          selectable: true,
        })) || [],
      [(division) => division.title?.toLowerCase()]
    )
  })
  const hasNextPage = ref(false)

  return {
    items,
    hasNextPage,
    fetchNextPage: () => {},
    isFetching: isLoadingDivisions,
    isFetched: isDivisionsLoaded,
    isInitialLoading: isLoadingDivisions,
  }
}

const valueResolver = async (id: string | null) => {
  const division = getDivisionByUuid.value(id)
  return { id, title: division?.name }
}

const updateNewValue = (newVal?: string | null) => {
  emit('input', newVal)
}

return { __sfc: true,props, emit, store, divisionsForHub, getDivisionByUuid, isLoadingDivisions, isDivisionsLoaded, divisions, searchDivisions, valueResolver, updateNewValue, NewAutocomplete }
}

})